
import { Component, Vue, namespace } from 'nuxt-property-decorator';
import { EventDto, PageDto, WebsiteHeaderProps } from 'fourwaves-shared';
import { WebsiteHeader } from 'fourwaves-shared/components';

const EventsModule = namespace('events');

@Component({
  components: { WebsiteHeader },
})
export default class HomeHeader extends Vue {
  @EventsModule.Getter currentEvent!: EventDto;
  @EventsModule.Getter registrationPage!: PageDto;
  @EventsModule.Getter submissionPage!: PageDto;

  get websiteHeaderProps(): WebsiteHeaderProps {
    return {
      headerSection: this.currentEvent.headerSection,
      name: this.currentEvent.name,
      startDate: this.currentEvent.startDate,
      endDate: this.currentEvent.endDate,
      type: this.currentEvent.type,
      place: this.currentEvent.place,
      forms: this.currentEvent.forms,
      registrationPage: this.registrationPage,
      submissionPage: this.submissionPage,
    };
  }

  public mounted() {
    this.$eventBus.emit('header:mounted', true);
  }

  public destroyed() {
    this.$eventBus.emit('header:destroyed', false);
  }

  public progressChangeHandler(progress: number) {
    this.$eventBus.emit('header:visibility-progress-changed', progress);
  }
}
